const statusMark = (value) =>
  value === 'pass' ? 'PASS' : value === 'fail' ? 'FAIL' : 'SKIP';

export const createSummary = (report) => {
  const lines = [
    `HomeSight network diagnostic: ${report.verdict.label}`,
    '',
    `Portal access ........... ${statusMark(report.reachability.portal)}`,
    `API access .............. ${statusMark(report.reachability.api)}`,
    `Notifications ........... ${statusMark(report.reachability.wss)}`,
    `Authentication .......... ${statusMark(report.reachability.oauth)}`,
    `WebRTC ICE (host) ....... ${report.webrtc.hostCandidates > 0 ? 'PASS' : 'FAIL'}`,
    `STUN (reflexive) ........ ${report.webrtc.srflxCandidates > 0 ? 'PASS' : 'FAIL'}`,
    `TURN relay .............. ${report.webrtc.relayCandidates > 0 ? 'PASS' : 'FAIL'}`,
    `UDP media path .......... ${report.webrtc.udp ? 'PASS' : 'FAIL'}`,
    '',
    `VERDICT: ${report.verdict.label}`,
    `LIKELY CAUSE: ${report.verdict.primaryCause || 'None identified'}`,
    `RECOMMENDATION: ${report.verdict.recommendation || 'None'}`,
  ];
  return lines.join('\n');
};

export const downloadReport = (report) => {
  const blob = new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `homesight-diagnostic-${report.reportId || 'report'}.json`;
  anchor.click();
  URL.revokeObjectURL(url);
};
